import Fetch from 'jsx/common/util/_fetch';

export const approve = async (id: string, message = '') => {
  return Fetch.put(`/api/remote-request/${id}/allow/`, {
    body: JSON.stringify({ message }),
  });
};

export const decline = async (id: string, message = '') => {
  return Fetch.put(`/api/remote-request/${id}/deny/`, {
    body: JSON.stringify({ message }),
  });
};

export const revoke = async (id: string, message = '') => {
  return Fetch.put(`/api/remote-request/${id}/revoke/`, {
    body: JSON.stringify({ message }),
  });
};

export default {
  approve,
  decline,
  revoke,
};
